import React, { Fragment, useState } from "react";
import PropTypes from "prop-types";

import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";

const Header = styled(DialogTitle)(() => ({
  position: "relative",
  margin: 0,
  padding: 0,
  display: "flex",
  alignItems: "center"
}));

const Title = styled(Typography)(({ theme }) => ({
  paddingLeft: theme.spacing(2),
  paddingTop: theme.spacing(2),
  marginLeft: 0,
  marginRight: "auto"
}));

function SessionRevokedModal({ socket, book, ulid, kind }) {
  const [aborted, setAborted] = useState(false);

  function onOkClick() {
    socket.message({
      type: "KILL_SESSION",
      book,
      ulid
    });
  }

  function onAbortClick() {
    socket.message({ type: "ABORT_SESSION" });
    setAborted(true);
    window.close();
  }

  function renderDialogContent() {
    return aborted ? (
      <>
        <p>Bitte schliessen Sie den Tab.</p>
        <p>Sie können das Buch über das Bücherregal erneut öffnen.</p>
      </>
    ) : (
      <>
        <p>Sie sind noch auf einem anderen Gerät oder einem anderen Browser eingeloggt!</p>
        <p>Möchten Sie hier fortfahren?</p>
      </>
    );
  }

  return (
    <>
      <Header>
        <Title variant="h6" id={`${kind}-modal-title`}>
          Buch schon geöffnet
        </Title>
      </Header>
      <DialogContent>{renderDialogContent()}</DialogContent>
      {!aborted && (
        <DialogActions>
          <Button variant="text" color="primary" onClick={onAbortClick}>
            Abbrechen
          </Button>
          <Button variant="text" color="primary" onClick={onOkClick}>
            OK!
          </Button>
        </DialogActions>
      )}
    </>
  );
}

SessionRevokedModal.propTypes = {
  socket: PropTypes.object.isRequired,
  book: PropTypes.string.isRequired,
  ulid: PropTypes.string.isRequired,
  kind: PropTypes.string.isRequired
};

export default SessionRevokedModal;
